<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Categoria de Tipo de Registros</h3>
        </div>

        <!-- Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{ countFilter }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar Filtro"
              @click="ResetListRegisterType()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">
                  Registros
                </h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <b-input-group class="d-flex justify-content-end my-auto ml-0">
                  <h6 class="m-0">
                    {{ pagination.TotalItems | number }}
                    {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                  </h6>
                  <div class="dropdown m-0" :class="window.width < 1880 ? 'dropleft' : ''">
                    <button
                      class="btn btn-outline-secondary dropdown-toggle-ellipsis col-lg-12"
                      type="button"
                      v-b-tooltip.hover.right
                      title="Mais opções"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fas fa-ellipsis-v"></i>
                    </button>
                    <div class="dropdown-menu" id="dropTableOptions" aria-labelledby="dropdownMenuButton">
                      <a
                        class="dropdown-item"
                        href="#"
                        :class="loadingReport ? 'disabled' : ''"
                        v-on:click.stop="GetReport($event)"
                      >
                        <template v-if="loadingReport">
                          <loader :small="true" :isLoading="loadingReport"></loader>
                        </template>
                        <template v-else>
                          <i class="fas fa-check mr-2"></i>
                          Gerar Relatório
                        </template>
                      </a>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-12" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0">Código</th>
                    <th scope="col" class="border-0 ">Nome</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(RegisterType, index) in RegisterTypes" :key="index">
                    <td>{{ RegisterType.Code }}</td>

                    <td>{{ RegisterType.Name }}</td>

                    <!-- <td>{{ RegisterType.CodeFacilitator }}</td> -->

                    <!-- <td>{{ RegisterType.PaymentSchemeCredit != 0 ? RegisterType.PaymentSchemeCredit : "-" }}</td>
                    <td>{{ RegisterType.PaymentSchemeDebit != 0 ? RegisterType.PaymentSchemeDebit : "-" }}</td> -->
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a
                            v-if="$isAuthorize('RegisterType', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click.stop="OpenRegisterTypes($event, index, true)"
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="$isAuthorize('RegisterType', 'Update') && !RegisterType.IsExcluded"
                            class="dropdown-item"
                            href="#"
                            v-on:click.stop="OpenRegisterTypes($event, index)"
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            v-if="$isAuthorize('RegisterType', 'Delete') && !RegisterType.IsExcluded"
                            class="dropdown-item"
                            href="#"
                            v-on:click.stop="ConfirmDeleteRegisterTypes(RegisterType.Name, RegisterType.Id)"
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="RegisterTypes == undefined || RegisterTypes == null || RegisterTypes.length == 0">
                    <td colspan="6">Sem Registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      size="lg"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
      id="mFormRegisterTypes"
    >
      <!-- Loader -->
      <div v-if="loadingModal">
        <loader :is-loading="loadingModal"></loader>
      </div>

      <div v-else>
        <ValidationObserver tag="form" ref="RegisterTypesValidationForm">
          <d-form-row>
            <d-col v-if="pOpened != null" md="6" class="form-group">
              <label>Código</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-form-input
                  :class="validatedRegisterTypesForm | showValidateError(invalid)"
                  :disabled="true"
                  type="text"
                  v-model="infoRegisterType.Code"
                />
                <div class="invalid-feedback d-block" v-if="validatedRegisterTypesForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
            <d-col md="6" class="form-group">
              <label>Nome</label>
              <ValidationProvider rules="required" v-slot="{ errors, invalid }">
                <d-form-input
                  :class="validatedRegisterTypesForm | showValidateError(invalid)"
                  :disabled="isSeeing"
                  type="text"
                  v-model="infoRegisterType.Name"
                />
                <div class="invalid-feedback d-block" v-if="validatedRegisterTypesForm">
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>

          </d-form-row>
        </ValidationObserver>
      </div>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SaveRegisterTypes()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ pOpened != null ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>
    <b-modal :no-close-on-backdrop="true" :no-close-on-esc="false" centered id="mFilter" title="Filtros">
      <d-form-row>
        <d-col md="6" class="form-group">
          <label>Código</label>
          <input class="form-control" type="text" v-model="filter.Code" v-on:keyup.enter="Filter()" />
        </d-col>
        <d-col md="6" class="form-group">
          <label>Nome</label>
          <input class="form-control" type="text" v-model="filter.Name" v-on:keyup.enter="Filter()" />
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button @click="Filter()" class="btn btn-primary" title="Pesquisar" v-b-tooltip.hover.bottom variant="primary">
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          @click="ResetFilter()"
          class="input-group-text"
          title="Limpar filtros"
          v-b-tooltip.hover.bottom
          variant="primary"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('RegisterType', 'Add')"
      class="btn-float success"
      href="#"
      title="Novo campo"
      v-b-tooltip.hover
      v-on:click="OpenRegisterTypes($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
import decimalField from "../common/decimal-field.vue";

export default {
  name: "RegisterType",
  components: {
    decimalField
  },
  ListRegisterType: [],
  data: function() {
    return {
      modalTitle: "Novo Campo",
      labelName: "Controller",
      RegisterTypes: [],
      RegisterType: [],
      disabled: 0,
      countFilter: 0,
      idRegisterTypes: 0,
      selected_RegisterTypes: [],
      RegisterTypes_list: [],

      infoRegisterType: {
        Id: null,
        Code: null,
        Name: "",
        IsExcluded: false
      },
      filter: {
        Name: null,
        Code: null
      },
      isSeeing: false,
      loadingAddUpdate: false,
      loadingList: false,
      loadingModal: false,
      loadingReport: false,
      validatedRegisterTypesForm: false,

      pOpened: null,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10
      },
      window: {
        width: 0,
        height: 0
      }
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function() {
      this.ListRegisterType();
    },
    "pagination.RowsPerPage": function() {
      this.ListRegisterType();
    }
  },
  mounted() {
    this.ListRegisterType();
  },
  methods: {
    OpenModalFilter: function() {
      this.$bvModal.show("mFilter");
    },
    Filter: function() {
      this.$bvModal.hide("mFilter");
      this.ListRegisterType();
    },
    ResetFilter: function() {
      this.filter = {
        Code: null,
        Name: null
      };
    },

    OpenRegisterTypes: function(e, index, view) {
      e.preventDefault();
      this.validatedRegisterTypesForm = false;
      this.loadingAddUpdate = false;
      this.ResetInfoRegisterType();

      if (view == undefined && index != undefined) {
        // Edit
        this.modalTitle = "Editar módulo";
        this.pOpened = index;
        this.isSeeing = false;

        this.GetRegisterType(this.RegisterTypes[index].Id);
      } else if (view == undefined && index == undefined) {
        // Add new
        this.modalTitle = "Novo Módulo";
        this.pOpened = null;
        this.isSeeing = false;
      } else {
        // View
        this.modalTitle = "Detalhes do módulo";
        this.pOpened = index;
        this.isSeeing = true;

        this.GetRegisterType(this.RegisterTypes[index].Id);
      }
      this.$bvModal.show("mFormRegisterTypes");
    },
    SaveRegisterTypes: function() {
      this.validatedRegisterTypesForm = true;
      this.$refs.RegisterTypesValidationForm.validate().then(isValid => {
        if (isValid) {
          this.loadingAddUpdate = true;
          this.isSeeing = true;

          if (this.pOpened == null) {
            this.$store
              .dispatch("AddRegisterType", {
                Name: this.infoRegisterType.Name,
                
              })
              .then(() => {
                this.$makeToast("O campo foi cadastrado com sucesso.", "success", "Campo cadastrado");
                this.$bvModal.hide("mFormRegisterTypes");
                this.ListRegisterType();
              })
              .catch(error => {
                this.$makeToast("Tente novamente mais tarde.", "danger", "Erro ao criar campo", error);
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          } else {
            this.$store
              .dispatch("UpdateRegisterType", {
                Id: this.infoRegisterType.Id,
                Code: this.infoRegisterType.Code,
                Name: this.infoRegisterType.Name,
                
              })
              .then(() => {
                this.$makeToast("O Campo foi atualizado com sucesso.", "success", "Campo atualizado");
                this.$bvModal.hide("mFormRegisterTypes");
                this.ListRegisterType();
              })
              .catch(error => {
                this.$makeToast("Erro ao atualizar campo, tente novamente.", "danger", "Erro ao atualizar campo", error);
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          }
        }
      });
    },

    GetRegisterType: function(id) {
      this.loadingModal = true;
      if (this.id != 0) {
        this.$store
          .dispatch("GetRegisterType", { id: id })
          .then(response => {
            this.infoRegisterType = response;
          })
          .catch(error => {
            this.$makeToast("Um erro ocorreu ao carregar o campo", "danger", "Erro ao carregar o campo", error);
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    GetParamsData: function(deletePagination = false) {
      let data = {
        ...this.pagination,

        Code: this.filter.Code,
        Name: this.filter.Name,

        "Object.Code": this.filter.Code,
        "Object.Name": this.filter.Name,
        
      };
      delete data.TotalItems;

      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },

    GetReport: function(ev) {
      ev.preventDefault();
      this.loadingReport = true;
      const params = this.GetParamsData(true);
      this.$store
        .dispatch("ReportRegisterType", { params })
        .then(response => {
          if (hasValue(response.UrlReport)) {
            this.$makeToast("Aguarde a conclusão do download", "info", "Relatório gerado com sucesso");
            window.open(response.UrlReport, "_self");
          }
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao gerar o relatório", error);
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loadingReport = false;
          }, 1200);
        });
    },
    ResetListRegisterType: function() {
      this.ResetFilter();
      this.ListRegisterType();
    },
    ResetInfoRegisterType: function() {
      this.selected_RegisterType = null;
      this.infoRegisterType = {
        Id: null,
        Code: null,
        Name: "",
        
      };
    },
    ListRegisterType: function() {
      this.countFilter = 0;
      if (hasValue(this.filter.Code)) this.countFilter++;
      if (hasValue(this.filter.Name)) this.countFilter++;

      let data = {
        ...this.pagination,
        "Object.Code": this.filter.Code,
        "Object.Name": this.filter.Name
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListRegisterType", { params: data })
        .then(response => {
          this.RegisterTypes = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(
            "Um erro ocorreu ao listar os campos. Tente novamente.",
            "danger",
            "Erro ao listar os Campos",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },

    IsOnSelectedRegisterTypesList: function(RegisterTypesCode) {
      let result = this.infoRegisterType.PaymentSchemeDebit.find(elm => {
        return elm.Code == RegisterTypesCode;
      });
      return result == undefined ? false : true;
    },

    ConfirmDeleteRegisterTypes: function(Name, Id) {
      this.$makeMsgBox("Você tem certeza que deseja remover o item " + Name + " ?", "Confirmar", this.DeleteRegisterTypes, Id);
    },

    DeleteRegisterTypes: function(Id) {
      this.$store
        .dispatch("DeleteRegisterType", { id: Id })
        .then(() => {
          this.$makeToast("O Item foi removido com sucesso.", "success", "Removido!");
          this.ListRegisterType();
          this.$bvModal.hide("mFormRegisterTypes");
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao remover módulo.", error);
        });
    },

    preventDecimal(e) {
      if (e.Code == "Comma" || e.Code == "Period" || e.Code == "Minus") {
        e.preventDefault();
      }
    }
  }
};
</script>
<style scoped>
.td-with-subs {
  display: block;
}
.td-with-subs > span {
  font-size: 10pt;
  opacity: 0.75;
}
.td-span-style {
  font-size: 9pt;
  opacity: 0.75;
}
td {
  padding: 10px;
}
.tdEspaco {
  display: table;
  float: left;
  margin-right: 10px;
}
table {
  border-spacing: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/registerType.vue